var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.70833C0 4.33546 0 3.14902 0.469111 2.24594C0.864425 1.48493 1.48493 0.864425 2.24594 0.469111C3.14902 0 4.33546 0 6.70833 0H13.2917C15.6645 0 16.851 0 17.7541 0.469111C18.5151 0.864425 19.1356 1.48493 19.5309 2.24594C20 3.14902 20 4.33546 20 6.70833V13.2917C20 15.6645 20 16.851 19.5309 17.7541C19.1356 18.5151 18.5151 19.1356 17.7541 19.5309C16.851 20 15.6645 20 13.2917 20H6.70833C4.33546 20 3.14902 20 2.24594 19.5309C1.48493 19.1356 0.864425 18.5151 0.469111 17.7541C0 16.851 0 15.6645 0 13.2917V6.70833Z",
    fill: "#1265BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4889 6.2112C5.44711 6.2112 6.2239 5.43442 6.2239 4.47621C6.2239 3.51799 5.44711 2.74121 4.4889 2.74121C3.53069 2.74121 2.75391 3.51799 2.75391 4.47621C2.75391 5.43442 3.53069 6.2112 4.4889 6.2112Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81286 7.49342H10.6883V8.81068C10.6883 8.81068 11.4686 7.25009 13.5917 7.25009C15.4855 7.25009 17.0544 8.18305 17.0544 11.0268V17.0234H14.0746V11.7534C14.0746 10.0759 13.179 9.89139 12.4965 9.89139C11.0802 9.89139 10.8377 11.1131 10.8377 11.9722V17.0234H7.81286V7.49342Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.97646 7.49342H6.00135V17.0234H2.97646V7.49342Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.d0703b0f01358636358d3f71aa4fbf1a.svg";
export { ForwardRef as ReactComponent };